import { render, staticRenderFns } from "./modal-news-center.vue?vue&type=template&id=61798bba&scoped=true"
import script from "./modal-news-center.vue?vue&type=script&lang=js"
export * from "./modal-news-center.vue?vue&type=script&lang=js"
import style0 from "./modal-news-center.vue?vue&type=style&index=0&id=61798bba&prod&lang=scss"
import style1 from "./modal-news-center.vue?vue&type=style&index=1&id=61798bba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61798bba",
  null
  
)

export default component.exports